import React, { useState, useRef, useEffect } from "react";
import { MdOutlineMic, MdOutlineMicOff } from "react-icons/md";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import { useStores } from "../../store/index";
import {
  removeCharInSetence,
  scrollToBottomUsingId,
} from "../../services/reusable";
import { azureSpeechKey } from "../../helpers/constantVariables";
import { Flex, IconButton, Text } from "@radix-ui/themes";

const SPEECH_KEY = azureSpeechKey;
const REACT_APP_SPEECH_REGION =
  process.env.REACT_APP_SPEECH_REGION ?? "centralindia";

console.log("this is the region", REACT_APP_SPEECH_REGION);

export default function AzureSpeechToText({ isMutedd, toggleMuted }) {
  const { InterviewStore, PopupStore } = useStores();
  const [isListening, setIsListening] = useState(false);

  const speechConfig = useRef(null);
  const audioConfig = useRef(null);
  const recognizer = useRef(null);

  useEffect(() => {
    speechConfig.current = sdk.SpeechConfig.fromSubscription(
      SPEECH_KEY,
      REACT_APP_SPEECH_REGION
    );
    console.log("this is the region", REACT_APP_SPEECH_REGION);
    speechConfig.current.speechRecognitionLanguage = "en-IN";

    audioConfig.current = sdk.AudioConfig.fromDefaultMicrophoneInput();
    recognizer.current = new sdk.SpeechRecognizer(
      speechConfig.current,
      audioConfig.current
    );

    const scrollToBottom = () => {
      scrollToBottomUsingId("chat-input");
      scrollToBottomUsingId("cc-ref");
    };

    const processRecognizedTranscript = (event) => {
      const result = event.result;
      //   console.log("Recognition result:", result);

      if (result.reason === sdk.ResultReason.RecognizedSpeech) {
        const transcript = removeCharInSetence(result.text, ".");
        // const transcript = result.text;
        console.log("Transcript: -->", transcript);
        InterviewStore.appendUserVoiceInput(transcript);
        InterviewStore.setTranscription("");
        // Call a function to process the transcript as needed
      }
    };

    const processRecognizingTranscript = (event) => {
      const result = event.result;
      console.log("Recognition result:", result);
      if (result.reason === sdk.ResultReason.RecognizingSpeech) {
        const transcript = result.text;
        console.log("Transcript: -->", transcript);
        InterviewStore.setTranscription(transcript);
        scrollToBottom();
        // Call a function to process the transcript as needed
      }
    };

    recognizer.current.recognized = (s, e) => processRecognizedTranscript(e);
    recognizer.current.recognizing = (s, e) => processRecognizingTranscript(e);

    // recognizer.current.startContinuousRecognitionAsync(() => {
    //   console.log("Speech recognition started.");
    //   setIsListening(true);
    // });

    return () => {
      recognizer.current.stopContinuousRecognitionAsync(() => {
        setIsListening(false);
      });
    };
  }, []);

  useEffect(() => {
    if (isListening) {
      resumeListening();
    } else if (!isListening) {
      if (InterviewStore.micNotification) {
        InterviewStore.setNotificationText("Mic turned off");
        InterviewStore.setNotificationTimer(true);
        InterviewStore.setNotificationIcon(<MdOutlineMicOff />);
        InterviewStore.setShowNotification(true);
      }
      stopListening();
    }
  }, [isListening]);

  useEffect(() => {
    setIsListening(isMutedd);
  }, [isMutedd]);

  const pauseListening = () => {
    setIsListening(false);
    recognizer.current.stopContinuousRecognitionAsync();
    console.log("Paused listening.");
  };

  const resumeListening = () => {
    try {
      setIsListening(true);
      recognizer.current.startContinuousRecognitionAsync(() => {
        console.log("Resumed listening...");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const stopListening = () => {
    setIsListening(false);
    recognizer.current.stopContinuousRecognitionAsync(() => {
      console.log("Speech recognition stopped.");
    });
  };

  useEffect(() => {
    if (PopupStore.compiler) {
      stopListening();
    }
  }, [PopupStore.compiler]);

  const onClickButton = () => {
    InterviewStore.setMicNotification(true);
    toggleMuted(!isMutedd);
    // if (isListening) {
    //   stopListening();
    // } else {
    //   resumeListening();
    // }
  };

  return (
    <Flex
      direction="column"
      align="center"
      gap="4"
      className="mt-1 md:mt-3 mr-1"
    >
      <IconButton
        size={window.innerWidth < 768 ? "2" : "4"}
        variant={"ghost"}
        color={"gray"}
        onClick={onClickButton}
        style={{
          border: "1px solid rgba(204, 204, 204, 0.2)",
        }}
      >
        {isListening ? (
          <MdOutlineMic className="text-lg md:text-2xl lg:text-3xl" />
        ) : (
          <MdOutlineMicOff className="text-lg md:text-2xl lg:text-3xl" />
        )}
      </IconButton>
      {/* <Text size="1" color="gray" className=" hidden md:block lg:block">
        Mute
      </Text> */}
    </Flex>
  );
}
